import { render, staticRenderFns } from "./NoMortgageDataAlternativesPage.vue?vue&type=template&id=37349d8a&scoped=true"
import script from "./NoMortgageDataAlternativesPage.vue?vue&type=script&lang=js"
export * from "./NoMortgageDataAlternativesPage.vue?vue&type=script&lang=js"
import style0 from "./NoMortgageDataAlternativesPage.vue?vue&type=style&index=0&id=37349d8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37349d8a",
  null
  
)

export default component.exports